<template>
  <textarea class="app-textarea" :value="modelValue" :placeholder="placeholder" :rows="rows" @input="onInput" />
  <p v-if="errorMessage" class="small error-comment">
    {{ errorMessage }}
  </p>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { debounce } from 'lodash';

import { validateDescription } from '@/utils/validators';

const modelValue = defineModel<string>('modelValue', { default: '' });
const props = withDefaults(
  defineProps<{
    placeholder?: string;
    rows?: number;
  }>(),
  {
    placeholder: '',
    rows: 5,
  }
);
const { t } = useI18n();

const errorMessage = ref<string>('');

const validateTextArea = () => {
  const textareaError = validateDescription(modelValue.value);
  if (textareaError) {
    errorMessage.value = t(textareaError);
  } else {
    errorMessage.value = '';
  }
};

const debounceValidateTextArea = debounce(validateTextArea, 300);

const onInput = (e: Event) => {
  const target = e.target as HTMLTextAreaElement;
  modelValue.value = target.value;
  debounceValidateTextArea();
};
</script>

<style scoped lang="scss">
.error-comment {
  padding: 8px;
  background: $error-bg;
  color: $new-warning;
  margin-top: 5px;
}
</style>
